import EditRegion from "./Edit";

export default function AddRegion() {
  return <EditRegion mode="add" />;
}

